export interface EventsAccordionProps {
    event: any;
    selectedChild: any;
    handleCartDrawer: any;
}

export interface EventsCardProps {
    event: any;
    onRegisterClick: (event: any) => void;
    selectedChildId?: number;
}

export interface ExpandedAccordionsType {
    [key: string]: boolean;
}

export interface PricingDetail {
    id: number;
    eventId: number;
    description: string;
    startTime: string;
    endTime: string;
    chargeType: number;
    chargePerPeriod: string;
    chargePerPeriodSub: string;
    status: number;
    maxScheduleDays: number;
    isSelectScheduleAllowed: boolean;
    isDepositRequired: boolean;
    depositAmount: string;
    autoPaymentDate: string;
    sun: boolean;
    mon: boolean;
    tue: boolean;
    wed: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    createdAt: string;
    updatedAt: string;
    discountAmount: number;
    discountType: number;
}

export interface EventDetail {
  isRecurring: number;
  locationName: string;
  isVisible: number;
  id: number;
  name: string;
  description: string;
  images: { signedUrl: string }[];
  startDate: string;
  endDate: string;
  registrationStartDate: string;
  registrationEndDate: string;
  nextStartDate: string | null;
  minMonthsRestrictions: number;
  capacity: number;
  occupiedSeats: number;
  totalOccupiedSeats: number;
  status: number;
  pricing: PricingDetail[];
  isWaitlistEnabled: number;
  locationId: number;
  location?: {
    id: number;
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    countryCode: string;
    postal: string;
    region: string;
    address2: string;
  };
  categoryId: number;
  category?: {
    id: number;
    name: string;
  };
  programEnrollments: [
    {
      id: number;
      childId: number;
      startDate: string;
      endDate: string;
      status: number;
    },
  ];
  createdAt: string;
  updatedAt: string;
}

export interface CartSummaryProps {
  applyCouponCode?: (couponCode: string) => Promise<boolean>;
  readonly: boolean;
  checkout: boolean;
  showPayInFullText?: boolean;
}

export interface BillingFormProps {
  billingInfo: {
    savePreferred: boolean;
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phone: string;
    email: string;
  };
  setBillingInfo: React.Dispatch<
    React.SetStateAction<{
      savePreferred: boolean;
      firstName: string;
      lastName: string;
      address: string;
      city: string;
      state: string;
      zipCode: string;
      country: string;
      phone: string;
      email: string;
    }>
  >;
  handleNext: (stripeData: { token: string; brand: string; tokenPreferred: string }) => void;
}

export interface ChildrenAccordionProps {
  fname: string;
  lname: string;
  dob: string;
  gender: string;
  genders: string[];
  isNew: boolean;
  onDelete: () => void;
}

export interface ConfirmDialogProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  title: string;
  description: string;
}

export interface SnackbarProps {
  open: boolean;
  message: string;
  severity: string;
  handleClose: () => void;
  autoHideDuration?: number;
  linkLabel?: string;
  linkOnClick?: () => void;
}

export interface TextMaskCustomProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export interface ParentFormProps {
  title: string;
  subtitle?: string;
  disableInputs?: boolean;
  onParentDataChange?: (data: any) => void;
  onPasswordChange?: (password: string) => void;
}

export interface PayerInfoProps {
  billingInfo: {
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
  };
}

export interface RegisterButtonProps {
  selectedEventGroup: any;
  openModal: () => void;
}

export interface ErrorResponse {
  message: string;
}

export interface CartResponse {
  statusCode: number;
  isSuccess: boolean;
  data: {
    data: CartItem[];
    meta: {
      itemsPerPage: number;
      totalItems: number;
      currentPage: number;
      totalPages: number;
      sortBy: Array<[string, string]>;
      filter: {
        cartId: string;
      };
    };
    links: {
      current: string;
    };
    coupons: Coupon[];
  };
  invalidItems: CartItem[];
  invalidCoupons: Coupon[];
}

export interface PaymentMethodsResponse {
  statusCode: number;
  isSuccess: boolean;
  data: PaymentMethodParams;
}

export interface PaymentMethodParams {
  cardType: number;
  cardNumber: string;
  cardExpire: string;
  paymentType: number;
}

export enum PaymentMethodType {
  //ACH = 1,
  BANK = 1,
  VISA = 2,
  MASTERCARD = 3,
  AMEX = 4,
  DISCOVER = 5,
  JCB = 6,
  DINERS = 7,
  UNIONPAY = 8,
  DEFAULT = 0,
}

export interface ProcessingFeeResponse {
  statusCode: number;
  isSuccess: boolean;
  data: {
    description: string;
    percentage: number;
    amount: number;
  };
}

export interface CartItem {
  discountAmountCoupon: number;
  reservedSeats: number;
  invalidMessage: string;
  id: number;
  child: {
    id: number;
    firstName: string;
    lastName: string;
  };
  item: {
    id: number;
    chargeType: number;
    chargePerPeriod: string;
    status: number;
    isDepositRequired: boolean;
    depositAmount: string;
    autoPaymentDate: string;
    event: {
      id: number;
      name: string;
      status: number;
      capacity: number;
      occupiedSeats: number;
      startDate: string;
      endDate: string;
    };
  };
}

export interface Coupon {
  invalidMessage: string;
  id: string;
  coupon: {
    locationId: number;
    location: {
      id: number;
      name: string;
    };
    id: number;
    code: string;
    amount: number;
    status: number;
    type: number;
  };
}

export interface CartState {
  data: CartItem[];
  invalidItems: CartItem[];
  invalidCoupons: Coupon[];
  meta: {
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    totalPages: number;
    sortBy: Array<[string, string]>;
    filter: {
      cartId: string;
    };
  };
  links: {
    current: string;
  };
  coupons: Coupon[];
}

export interface OrderResponse {
  statusCode: number;
  isSuccess: boolean;
  data: {
    order: {
      uuid: string;
      total: number;
      depositTotal: number;
      status: number;
      items: OrderItem[];
      createdAt: string;
      updatedAt: string;
    };
    invalidMessages: string[];
    cartMessages: string[];
  };
}

export interface OrderItem {
  amount: string;
  depositAmount: string;
  id: number;
  createdAt: string;
  updatedAt: string;
}

export interface CompleteOrderResponse {
  statusCode: number;
  isSuccess: boolean;
  data: {
    id: string;
    last4: number;
    enrollmentDetails: EnrollmentDetail[];
  };
}

export interface EnrollmentDetail {
  childId: number;
  startDate: string;
}

export enum PaymentMethodEnum {
  BANK = 1,
  CARD = 2,
}

export interface CartItemType {
  cartMessages: string[];
  invalidCoupons: any[];
  invalidItems: any[];
  invalidMessages: string[];
  data: any[];
}

export enum PricingDiscountTypes {
  DISABLED = 0,
  FIXED = 1,
  PERCENTAGE = 2,
}

export interface Child {
  id: number;
  fname: string;
  lname: string;
  dob: string;
  gender: string;
  isNew: boolean;
}

export interface User {
  uid: string;
  fname: string;
  lname: string;
  email: string;
  phone: string;
  payerId: number;
  children: Child[];
  selectedChild?: Child;
}

export enum OrderErrors {
  DUPLICATE_CHARGE_PREVENTED = 'DUPLICATE_CHARGE_PREVENTED',
}
